const navigations = {
  ROOT: "/",
  CREATE_SAAS: "/saas/create-saas",
  FORGOT_PASSWORD: "/forgot-password",
  LOGIN: "/login",
  SIGNUP: "/signup",
  SAAS: "/saas",
  OUT_SOURCED: "*",
  RESET_PASSWORD: "/forgot-password/:id",
  USERS: "/users",
  CREATE_USER: "/users/create",
  ACCOUNTS: "/accounts",
  CREATE_ACCOUNT: "/accounts/create",
  COURSES: "/courses",
  CREATE_COURSE: "/courses/create",
  CREATE_CATEGORY: "/category",
  SUBCATEGORY: "/dentist/category/:categoryId/subcategory/:id",
  CATEGORIES: "/dentist/category",
  CATEGORY: "/dentist/category/:id",
  CATEGORY_COURSES: "/dentist/category/:id/courses",
  GROUPS: "/dentist/group",
  GROUP: "/dentist/group/:groupId",
  GROUP_CATEGORY: "/dentist/group/:groupId/category/:id",
  GROUP_SUBCATEGORY:
    "/dentist/group/:groupId/category/:categoryId/subcategory/:id",
  DENTIST_SETTING: "/dentist/account",
  SUBCAT: "/dentist/category",
  COURSE_TYPE: "/courses/type",
  CATEGORY_TYPE: "/category/type",
  LIVE_EXTERNSHIP: "/ciicourse",
  LIVE_EXTERNSHIP_OBSERVATION: "/ciicourse-observationTrack",
  LIVE_EXTERNSHIP_DENTAL_ASSISTANT:
    "/ciicourse-dentalAssistantObservationTrack",
  LIVE_EXTERNSHIP_CREATE_COURSE: "/ciicourse/courses/create",
  LIVE_EXTERNSHIP_OBSERVATION_CREATE_COURSE:
    "/ciicourse-observationTrack/courses/create",
  LIVE_EXTERNSHIP_DENTAL_ASSISTANT_CREATE_COURSE:
    "/ciicourse-dentalAssistantObservationTrack/courses/create",
  LIVE_EXTERNSHIP_CATEGORY: "/ciicourse/category",
  LIVE_EXTERNSHIP_OBSERVATION_CATEGORY: "/ciicourse-observationTrack/category",
  LIVE_EXTERNSHIP_DENTAL_ASSISTANT_CATEGORY:
    "/ciicourse-dentalAssistantObservationTrack/category",
  MASTER_OF_ORAL_IMPLANTOLOGY: "/masterOfOralImplantologyProgram",
  MASTER_OF_ORAL_IMPLANTOLOGY_CREATE_COURSE:
    "/masterOfOralImplantologyProgram/courses/create",
  MASTER_OF_ORAL_IMPLANTOLOGY_CATEGORY:
    "/masterOfOralImplantologyProgram/category",
  ONLINE_PROGRAM: "/onlinePrograms",
  ONLINE_PROGRAM_CATEGORY: "/onlinePrograms/category",
  ONLINE_PROGRAM_CREATE_COURSE: "/onlinePrograms/courses/create",
  ONLINE_PROGRAM_REQUEST: "/onlineProgramRequest",
  CADAVER_PROGRAM: "/handsOnProgram",
  CADAVER_PROGRAM_CATEGORY: "/handsOnProgram/category",
  CADAVER_PROGRAM_CREATE_COURSE: "/handsOnProgram/courses/create",
  LIVE_LECTURES: "/liveLectures",
  LIVE_LECTURES_CATEGORY: "/liveLectures/category",
  LIVE_LECTURES_CREATE_COURSE: "/liveLectures/courses/create",
  HOME: "/home",
  PURCHASE_ONLINE_PROGRAMS: "/purchaseOnlinePrograms",
  SUBSCRIPTIONS: "/subscriptions",
  USERS_TEST_ATTEMPTS: "/users-test-attempts",
  SPEAKERS: "/speakers",
};

export default navigations;
